import ApiService from './service';
import * as http from './http';

export class ChatbotService extends ApiService {

    async getMarketingResponse(data) {
        const url = `${this.apiDomain}/api/chatbot/marketing/question`;
        try {
            const response = await http.post(url, data, this.store);
            return response.data;
        } catch (error) {
            console.error('Error fetching marketing response:', error);
            return null;
        }
    }

    async getQuestionResponse(data) {
        const url = `${this.apiDomain}/api/chatbot/question`;  
        try {
            const response = await http.post(url, data, this.store);
            return response.data;
        } catch (error) {
            console.error('Error fetching question response:', error);
            return null;
        }
    }
    async getFAQs() {
        const url = `${this.apiDomain}/api/chatbot/faqs`;
        try {
            const response = await http.get(url, this.store);
            return response.data;
        } catch (error) {
            console.error('Error fetching FAQs:', error);
            return null;
        }
    }

    async updateFAQs(string_to_search) {
        const url = `${this.apiDomain}/chatbot/faqs/update?string_to_search=${encodeURIComponent(string_to_search)}`;
        try {
            const response = await http.post(url, {}, this.store);
            return response.data;
        } catch (error) {
            console.error('Error updating FAQ:', error);
            return null;
        }
    }
}
